function mobilemenu()
{
    const banner = document.querySelector('.banner');
    const icon = document.getElementById('menu-icon');
    const mobileMenu = document.querySelector('.mobile-menu-wrapper');

    if (icon) {
        icon.addEventListener('click', function () {
            icon.classList.toggle('is-open');
            mobileMenu.classList.toggle('is-open');
            banner.classList.toggle('scrolled');
            document.body.classList.toggle('no-scroll');
        });
    }


}

export { mobilemenu };
